import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { LoaderContext } from "../../../App";
import UOMService from "../../../core/service/UOMService";
import { toast } from "react-toastify";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import useHasPermission from "../../../core/hooks/useHasPermission";

const UomVersionFormModal = ({ t, show, onHide, version, onSuccess }) => {
	const isEdit = !!version;
	const [versionName, setVersionName] = useState("");
	const [description, setDescription] = useState("");
	const [saving, setSaving] = useState(false);
	const { setLoaderDisplay } = useContext(LoaderContext);
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY) || "null");
	const { isSuperAdmin } = useHasPermission();
	const getCompanyId = () => {
		if (isSuperAdmin && isSuperAdmin()) {
		 return null;
		}
		return lsData?.profile?.company?.id || null;
	};
	const companyId = getCompanyId();

	useEffect(() => {
		if (isEdit) {
			setVersionName(version.versionName || "");
			setDescription(version.description || "");
		} else {
			setVersionName("");
			setDescription("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEdit, version?.id]);

	const handleSubmit = () => {
		if (!versionName?.trim()) {
			toast.error(t("EmissionDatasetVersionManagement.form.versionName.required.label") || "Version name required");
			return;
		}
		const payload = {
			versionName: versionName.trim(),
			description: description?.trim() || ""
		};
		setSaving(true);
		setLoaderDisplay(true);
		const req = isEdit
			? UOMService.updateVersion(version.versionNumber, payload, companyId)
			: UOMService.createVersion(payload, companyId);
		req
			.then((res) => {
				if (res.status === 200 || res.status === 201) {
					onSuccess && onSuccess();
					toast.success(
						isEdit
							? (t("EmissionDatasetVersionManagement.updateSuccess.label") || "Updated successfully")
							: (t("EmissionDatasetVersionManagement.createSuccess.label") || "Created successfully")
					);
				}
			})
			.catch(() => {})
			.finally(() => {
				setSaving(false);
				setLoaderDisplay(false);
			});
	};

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>
					{isEdit
						? (t("EmissionDatasetVersionManagement.editVersion.label") || "Edit Version")
						: (t("EmissionDatasetVersionManagement.newVersion.label") || "New Version")}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-3">
					<Form.Label>{t("EmissionDatasetVersionFormModal.versionName.label") || "Version Name"}</Form.Label>
					<Form.Control
						type="text"
						value={versionName}
						onChange={(e) => setVersionName(e.target.value)}
						data-testid="uom-version-name"
					/>
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label>{t("Description.label") || "Description"}</Form.Label>
					<Form.Control
						as="textarea"
						rows={3}
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						data-testid="uom-version-description"
					/>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onHide}>
					{t("Cancel.label")}
				</Button>
				<Button variant="primary" onClick={handleSubmit} disabled={saving}>
					{isEdit ? (t("Save.label") || "Save") : (t("Create.label") || "Create")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default withTranslation()(UomVersionFormModal);

